import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { ChatBubble, PhoneIphone as PhoneIcon, StayPrimaryPortrait } from '@material-ui/icons';
import EmailBouncedIcon from '../../assets/icons/emailBouncedIcon.svg';
import EmailClickedIcon from '../../assets/icons/emailClickedIcon.svg';
import EmailDeliveredIcon from '../../assets/icons/emailDeliveredIcon.svg';
import EmailOpenedIcon from '../../assets/icons/emailOpenedIcon.svg';
import EmailSentIcon from '../../assets/icons/emailSentIcon.svg';
import { useCampfireTheme } from '../../theme/useCampfireTheme';

export type CommunicationStatus = 'sent' | 'delivered' | 'opened' | 'clicked' | 'bounced' | 'failed' | 'replied';

const LABELS: Record<CommunicationStatus, string> = {
  sent: 'Sent',
  delivered: 'Delivered',
  opened: 'Opened',
  clicked: 'Clicked',
  bounced: 'Bounced',
  failed: 'Failed',
  replied: 'Replied',
};

const EMAIL_ICONS: Partial<Record<CommunicationStatus, string>> = {
  sent: EmailSentIcon,
  delivered: EmailDeliveredIcon,
  opened: EmailOpenedIcon,
  clicked: EmailClickedIcon,
  bounced: EmailBouncedIcon,
  failed: EmailBouncedIcon,
};

interface CommunicationStatusChipProps {
  status: CommunicationStatus;
  channel: 'sms' | 'email';
  count?: number;
}

/**
 * The status chip shown against a message everywhere: the profile's Communications tab and the
 * Communications page. Colours and icons follow the original profile email list.
 */
export const CommunicationStatusChip = ({ status, channel, count }: CommunicationStatusChipProps) => {
  const { theme } = useCampfireTheme();

  const colors: Record<CommunicationStatus, string> = {
    sent: '#83C4A0',
    delivered: '#48976C',
    opened: '#2FC0F9',
    clicked: '#7570EA',
    bounced: '#D93A00',
    failed: '#D93A00',
    replied: theme.color.secondary.main900,
  };

  const emailIcon = channel === 'email' ? EMAIL_ICONS[status] : undefined;

  return (
    <Box
      display='inline-flex'
      alignItems='center'
      style={{
        backgroundColor: colors[status],
        borderRadius: '3px',
        padding: '0 8px',
        height: 22,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap',
      }}
    >
      {emailIcon ? (
        <img src={emailIcon} alt='' style={{ marginRight: '4px' }} />
      ) : status === 'replied' ? (
        <Box display='flex' alignItems='flex-start' mr='4px'>
          <StayPrimaryPortrait style={{ width: '10px', height: '10px', color: '#ffffff' }} />
          <ChatBubble style={{ width: '10px', height: '7px', color: '#ffffff', marginLeft: '-2px' }} />
        </Box>
      ) : (
        <PhoneIcon style={{ width: '10px', height: '10px', color: '#ffffff', marginRight: '4px' }} />
      )}
      <Typography style={{ fontWeight: 600, fontSize: '11px', color: '#FCFCFC' }}>
        {count !== undefined ? `${count} ${LABELS[status].toLowerCase()}` : LABELS[status]}
      </Typography>
    </Box>
  );
};
